import { Block, BottomSheet, Button, Typography, spacing } from "@stepapp/ui";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { useErrorMessage } from "../../hooks";

type ErrorMsgTypes =
  | "wrongSmsOrPhoneNumber"
  | "completeReservationChangeError"
  | "confirmPaymentError"
  | string;

type Props = {
  setErrorMsg: (v: string | undefined) => void;
  errorTitle?: string;
  errorMsg?: ErrorMsgTypes;
  fallbackErrorMsg?: string;
};

const ErrorModal = ({
  setErrorMsg,
  errorMsg,
  errorTitle = "common.error",
  fallbackErrorMsg = "alerts.sthWentWrong",
}: Props) => {
  const { t } = useTranslation();
  const errorMessage = useErrorMessage();

  //@ts-expect-error
  const msg = errorMessage(errorMsg || "") ?? t(fallbackErrorMsg);

  const handleDismiss = useCallback(() => {
    setErrorMsg(undefined);
  }, [setErrorMsg]);

  return (
    <BottomSheet contentStyle={styles.deleteContainer} toggle={handleDismiss} visible={!!errorMsg}>
      <Block alignCenter>
        {/* @ts-expect-error */}
        <Typography variant="newH3">{t(errorTitle)}</Typography>
        <Block marginBottom={3} marginTop={1.5}>
          <Typography center type="secondary" variant="lightLabel">
            {msg}
          </Typography>
        </Block>
      </Block>
      <Button label={t("common.goBack")} onPress={handleDismiss} type="primary" />
    </BottomSheet>
  );
};

export default ErrorModal;

const styles = StyleSheet.create({
  deleteContainer: {
    padding: spacing.unit * 2.5,
  },
});
